var map = {
	"./app-apple-da-DK.svg": 7624,
	"./app-apple-de-DE.svg": 80714,
	"./app-apple-en-GB.svg": 77064,
	"./app-apple-en-US.svg": 14915,
	"./app-apple-es-ES.svg": 37204,
	"./app-apple-es-MX.svg": 40727,
	"./app-apple-fr-FR.svg": 70588,
	"./app-apple-it-IT.svg": 57170,
	"./app-apple-nb-NO.svg": 37121,
	"./app-apple-nl-NL.svg": 81112,
	"./app-apple-pl-PL.svg": 21168,
	"./app-apple-pt-BR.svg": 65404,
	"./app-apple-pt-PT.svg": 19808,
	"./app-apple-sv-SE.svg": 94177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28065;